import { format, isWeekend } from 'date-fns';
import { ru } from 'date-fns/locale';
import { cn } from '@shared/lib/utils';
import type { FC } from 'react';
import type { EventResponse, VenueInfoResponse } from '../../models/show.interface';
import { EventItem } from './EventItem';

interface DayGroupProps {
  date: Date;
  events: EventResponse[];
  venueInfo: VenueInfoResponse | null;
  handleSelectDate: (date: string, time: string, eventId: number) => void;
}

// Компонент для отображения группы событий в один день
export const DayGroup: FC<DayGroupProps> = ({ date, events, venueInfo, handleSelectDate }) => {
  const day = format(date, 'd', { locale: ru });
  const month = format(date, 'MMMM', { locale: ru });
  const label = format(date, 'EEEE', { locale: ru });

  const weekend = isWeekend(date);

  return (
    <div key={format(date, 'yyyy-MM-dd')} className="w-full border-t border-separator p-0">
      <div className="grid grid-cols-1 xs:grid-cols-[auto_1fr] sm:grid-cols-[auto_1fr] md:grid-cols-[260px_1fr] items-stretch gap-1 xs:gap-2 sm:gap-x-4 md:gap-x-6 lg:gap-x-8 w-full">
        {/* Дата и день недели */}
        <div className="flex items-center h-full">
          <div className="flex flex-row items-center gap-3 w-full h-full">
            <div className="w-[2ch] shrink-0 text-right text-5xl sm:text-6xl font-light leading-none tabular-nums">
              {day}
            </div>
            <div className="flex flex-col self-center leading-none">
              <div
                className={cn(
                  'text-[10px] xs:text-xs uppercase tracking-wide font-semibold leading-none',
                  weekend ? 'text-status-error' : 'text-text-muted'
                )}
              >
                {label}
              </div>
              <div className="text-xl leading-none text-text-primary sm:text-2xl">{month}</div>
            </div>
          </div>
        </div>

        {/* Список событий */}
        <div className="flex flex-col w-full mt-2 xs:mt-1 sm:mt-0">
          {events.map(event => (
            <EventItem
              key={event.id}
              event={event}
              venueInfo={venueInfo}
              handleSelectDate={handleSelectDate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
